// Moved to @livingsyncs/ui (frontend split epic, Phase 5 Task 5.2 follow-up
// — needed by StaffFormsSection's own useFormSubmissions call, transitively).
// Shim kept so nothing importing the old path breaks — many other
// frontend-only consumers (useMyTasks, useTaskSubscriptions, etc.).
//
// Real function DECLARATIONS that call through, not reference copies or
// pass-through re-exports — see hooks/useAuth.ts's note for why (automock
// compatibility).
import type { QueryClient } from "@tanstack/react-query";
import * as _module from "@livingsyncs/ui";

export function invalidateTaskSurfaces(qc: QueryClient): void {
  _module.invalidateTaskSurfaces(qc);
}

export function invalidateResidentTimeline(qc: QueryClient): void {
  _module.invalidateResidentTimeline(qc);
}
